/*-----------------------------------------------------------------
- Marketplace
-----------------------------------------------------------------*/

export default {
    title             : 'المتجر',
    'case-study-title': 'قصص نجاح حقيقية مع كواركينو',
};
